/* src/app/cardholders/cardholder-visaforward/cardholder-visaforward.component.css */
.fa {
  font-size: 9pt;
}
/*# sourceMappingURL=cardholder-visaforward.component.css.map */
